export enum AppRoutes {
    AccountsManagement,
    Marketing,
    Fleet,
}

export const AppRouteProps: Record<AppRoutes, { path: string }> = {
    [AppRoutes.AccountsManagement]: {
        path: '/accounts-management',
    },
    [AppRoutes.Marketing]: {
        path: '/marketing',
    },
    [AppRoutes.Fleet]: {
        path: '/fleet',
    },
};
